"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.areGetProductMarketingVariantByBrandContraintsMet = exports.CARDLESS_POINTS_TYPE = exports.RewardsError = exports.RewardsEndpoints = exports.RewardsAccountLookupError = exports.RedemptionMode = exports.PurchasedGiftCardStatusReasonCode = exports.PurchasedGiftCardStatus = exports.PointsStatus = exports.PassTimePeriod = exports.OutcomeType = exports.GoalType = exports.EventProcessStatus = exports.EarningMode = exports.CodeType = exports.BenefitType = exports.AdjustmentMode = void 0;
const CARDLESS_POINTS_TYPE = 'cardless';
exports.CARDLESS_POINTS_TYPE = CARDLESS_POINTS_TYPE;
var RewardsEndpoints;
(function (RewardsEndpoints) {
    RewardsEndpoints["CheckIfUserExistsOnPartner"] = "/rewards/check-if-user-exists-on-partner";
    RewardsEndpoints["ClaimBenefit"] = "/rewards/claim-benefit";
    RewardsEndpoints["CompleteExternalOauthLogin"] = "/rewards/complete-external-oauth-login";
    RewardsEndpoints["GetBenefitsByAccount"] = "/rewards/get-benefits-for-account";
    RewardsEndpoints["GetBenefitDetails"] = "/rewards/get-benefit-details";
    RewardsEndpoints["GetBrandShopByAccount"] = "/rewards/get-brand-shop-by-account";
    RewardsEndpoints["GetEarningRatesByAccount"] = "/rewards/get-earning-rates-by-account";
    RewardsEndpoints["GetEligibleCharitiesForRedemption"] = "/rewards/get-eligible-charities-for-redemption";
    RewardsEndpoints["GetExternalLoginUrl"] = "/rewards/get-external-login-url";
    RewardsEndpoints["GetHistoricalGoalsByAccount"] = "/rewards/get-historical-goals-by-account";
    RewardsEndpoints["GetHistoricalGoalsByUser"] = "/rewards/get-historical-goals-by-user";
    RewardsEndpoints["GetGiftCardCatalog"] = "/rewards/get-gift-card-catalog";
    RewardsEndpoints["GetProductMarketingVariant"] = "/rewards/get-product-marketing-variant";
    RewardsEndpoints["GetProductMarketingVariantByBrand"] = "/rewards/get-product-marketing-variant-by-brand";
    RewardsEndpoints["GetPointsEntriesByAccount"] = "/rewards/get-points-entries-by-account";
    RewardsEndpoints["GetPointsEntriesByEvent"] = "/rewards/get-points-entries-by-event";
    RewardsEndpoints["GetPointsMultiplierDetails"] = "/rewards/get-points-multiplier-details";
    RewardsEndpoints["GetPurchasedGiftCardForAccount"] = "/rewards/get-purchased-gift-card-for-account";
    RewardsEndpoints["GetPurchasedGiftCardsForAccount"] = "/rewards/get-purchased-gift-cards-for-account";
    RewardsEndpoints["GetRedemptionRatesByAccount"] = "/rewards/get-redemption-rates-by-account";
    RewardsEndpoints["GetReferralInfoByAccount"] = "/rewards/get-referral-info-by-account";
    RewardsEndpoints["GetTransferRatesForRedemption"] = "/rewards/get-transfer-rates-for-redemption";
    RewardsEndpoints["PurchaseGiftCardFromCatalog"] = "/rewards/purchase-gift-card-from-catalog";
    RewardsEndpoints["RedeemPointsForBrandShopPurchase"] = "/rewards/redeem-points-for-brand-shop-purchase";
    RewardsEndpoints["RedeemPointsForCharity"] = "/rewards/redeem-points-for-charity";
    RewardsEndpoints["RedeemPointsForGiftCard"] = "/rewards/redeem-points-for-gift-card";
    RewardsEndpoints["RedeemPointsForStatementCredit"] = "/rewards/redeem-points-for-statement-credit";
})(RewardsEndpoints || (exports.RewardsEndpoints = RewardsEndpoints = {}));
/**
 * Defines the processing status of an event.
 * e.g. Can be used to determine whether points have been generated for a given transaction event.
 */
var EventProcessStatus;
(function (EventProcessStatus) {
    EventProcessStatus["Unspecified"] = "EVENT_PROCESS_STATUS_UNSPECIFIED";
    /**
     * The given event has not yet been processed.
     * This could mean that it will never be processed, or that it hasn't been processed yet.
     */
    EventProcessStatus["Pending"] = "PENDING_PROCESSING";
    /**
     * The given event has been processed.
     * Points entries associated with the event are final.
     */
    EventProcessStatus["Processed"] = "PROCESSED";
})(EventProcessStatus || (exports.EventProcessStatus = EventProcessStatus = {}));
/**
 * Ways to adjust points.
 * This is used to categorize how points were adjusted, when PointsEntryMode = ADJUSTMENT.
 * e.g. Adjust points to appease user.
 */
var AdjustmentMode;
(function (AdjustmentMode) {
    AdjustmentMode["Unspecified"] = "ADJUSTMENT_MODE_UNSPECIFIED";
    /** Points were credited. */
    AdjustmentMode["Credit"] = "CREDIT";
    /** Points were debited. */
    AdjustmentMode["Debit"] = "DEBIT";
})(AdjustmentMode || (exports.AdjustmentMode = AdjustmentMode = {}));
/**
 * Ways to earn points.
 * This is used to categorize how points were earned.
 */
var EarningMode;
(function (EarningMode) {
    EarningMode["Unspecified"] = "EARNING_MODE_UNSPECIFIED";
    /**
     * This PointsEntry is associated with a specific transaction.
     * Points are added to the appropriate PointsBalance.
     * transaction_uuid must also be set to link this to a transaction in Transactions Service
     * e.g. spending $5 for coffee results in 5 rewards points.
     */
    EarningMode["Transaction"] = "TRANSACTION";
    /**
     * This PointsEntry is a grant of Points, not associated with a specific transaction or redemption.
     * Rewards points will be added to the account's rewards balance.
     * e.g. a brand issues 500 rewards points to each cardholder after spending their $500.
     */
    EarningMode["Bonus"] = "BONUS";
    /**
     * This PointsEntry is a grant of Points, not associated with a specific transaction or redemption.
     * Rewards points will be added to the account's rewards balance.
     * e.g. A referred user is approved and we award the referrer 10K points.
     */
    EarningMode["Referral"] = "REFERRAL";
})(EarningMode || (exports.EarningMode = EarningMode = {}));
/**
 * Ways to redeem points.
 * This is used to categorize how points were redeemed, when PointsEntryMode = REDEMPTION.
 * e.g. Redeem points for statement credit.
 */
var RedemptionMode;
(function (RedemptionMode) {
    RedemptionMode["Unspecified"] = "REDEMPTION_MODE_UNSPECIFIED";
    /** Points were redeemed for a statement credit. */
    RedemptionMode["StatementCredit"] = "STATEMENT_CREDIT";
    /** Points redeemed to receive cash back */
    RedemptionMode["CashBack"] = "CASH_BACK";
    /** Points were redeemed for a donation to charity. */
    RedemptionMode["Charity"] = "CHARITY";
    /** Points were redeemed to purchase a gift card from a sports brand (not incomm). */
    RedemptionMode["GiftCard"] = "GIFT_CARD";
    /** Points were redeemed to transfer to a third party. */
    RedemptionMode["Transfer"] = "TRANSFER";
    /** Points were redeemed to purchase a brand shop product. */
    RedemptionMode["BrandShopProduct"] = "BRAND_SHOP_PRODUCT";
})(RedemptionMode || (exports.RedemptionMode = RedemptionMode = {}));
/**
 * Defines the result of processing an action through this campaign.
 * Mirrors ActionRuleOutcome.OutcomeType.
 */
var OutcomeType;
(function (OutcomeType) {
    OutcomeType["Unspecified"] = "OUTCOME_TYPE_UNSPECIFIED";
    /** Points are generated. */
    OutcomeType["Points"] = "POINTS";
    /** Statement credit is generated. */
    OutcomeType["StatementCredit"] = "STATEMENT_CREDIT";
})(OutcomeType || (exports.OutcomeType = OutcomeType = {}));
/**
 * The type of benefit
 */
var BenefitType;
(function (BenefitType) {
    BenefitType["Unspecified"] = "BENEFIT_TYPE_UNSPECIFIED";
    /** The benefit requires a code to access */
    BenefitType["Code"] = "CODE";
    /** The benefit is ongoing and does not need a code to access */
    BenefitType["Ongoing"] = "ONGOING";
    /**
     * The benefit is a pass that can be used x times
     * over some time period and therefore has a benefit goal attached to it
     */
    BenefitType["Pass"] = "PASS";
})(BenefitType || (exports.BenefitType = BenefitType = {}));
/**
 * The type of code
 */
var CodeType;
(function (CodeType) {
    CodeType["Unspecified"] = "CODE_TYPE_UNSPECIFIED";
    /** This is a unique code issued to one account. */
    CodeType["Unique"] = "UNIQUE";
    /** This is a generic code shared by all accounts. */
    CodeType["Generic"] = "GENERIC";
})(CodeType || (exports.CodeType = CodeType = {}));
var PassTimePeriod;
(function (PassTimePeriod) {
    PassTimePeriod["Year"] = "YEAR";
})(PassTimePeriod || (exports.PassTimePeriod = PassTimePeriod = {}));
var PurchasedGiftCardStatus;
(function (PurchasedGiftCardStatus) {
    PurchasedGiftCardStatus["Unspecified"] = "PURCHASED_GIFT_CARD_STATUS_UNSPECIFIED";
    PurchasedGiftCardStatus["Pending"] = "PURCHASED_GIFT_CARD_STATUS_PENDING";
    PurchasedGiftCardStatus["Success"] = "PURCHASED_GIFT_CARD_STATUS_SUCCESS";
    PurchasedGiftCardStatus["Error"] = "PURCHASED_GIFT_CARD_STATUS_ERROR";
})(PurchasedGiftCardStatus || (exports.PurchasedGiftCardStatus = PurchasedGiftCardStatus = {}));
var PurchasedGiftCardStatusReasonCode;
(function (PurchasedGiftCardStatusReasonCode) {
    PurchasedGiftCardStatusReasonCode["Unspecified"] = "PURCHASED_GIFT_CARD_STATUS_REASON_CODE_UNSPECIFIED";
})(PurchasedGiftCardStatusReasonCode || (exports.PurchasedGiftCardStatusReasonCode = PurchasedGiftCardStatusReasonCode = {}));
const areGetProductMarketingVariantByBrandContraintsMet = ({ brandSlug, utmTags, productSlug, }) => {
    return !!brandSlug || (!!productSlug && !!utmTags.campaign);
};
exports.areGetProductMarketingVariantByBrandContraintsMet = areGetProductMarketingVariantByBrandContraintsMet;
/**
 * The status of the points item.
 * Only {@link PointsStatus.Settled} points have been applied to balance.
 */
var PointsStatus;
(function (PointsStatus) {
    PointsStatus["Unspecified"] = "POINTS_STATUS_UNSPECIFIED";
    /** This points item is waiting to be settled. */
    PointsStatus["Pending"] = "PENDING";
    /** This points item has been settled to a rewards account. */
    PointsStatus["Settled"] = "SETTLED";
    /** There was an error settling this points item to a rewards account. */
    PointsStatus["Error"] = "ERROR";
    /**
     * Points that have been deemed invalid and are not intended to settle due
     * to account standing.
     */
    PointsStatus["Invalid"] = "INVALID";
    /**
     * Points attached to accounts that are frozen for suspected fraud or delinquent
     * They will not be settled unless the account is remedied.
     */
    PointsStatus["Suspended"] = "SUSPENDED";
    /**
     * Points entries for a given statement cycle are LOCKED when the account has not
     * hit the N transaction minimum for {@link GoalType.UnlockAndEarnActionCount}.
     */
    PointsStatus["Locked"] = "LOCKED";
    /**
     * Points entries are marked as SETTLEMENT_REQUIREMENTS_NOT_MET after the statement
     * cycle ends and the account has not hit the N transaction minimum for
     * {@link GoalType.UnlockAndEarnActionCount}.
     */
    PointsStatus["SettlementRequirementsNotMet"] = "SETTLEMENT_REQUIREMENTS_NOT_MET";
})(PointsStatus || (exports.PointsStatus = PointsStatus = {}));
/**
 * See {@link GoalProgress.type}
 */
var GoalType;
(function (GoalType) {
    /**
     * At the time of implementation, this goal is no longer used
     * and is only included here in case it is ever used again
     */
    GoalType["DoublePoints"] = "DOUBLE_POINTS";
    /**
     * A goal with a spend requirement which when hit unlocks a reward
     */
    GoalType["SpendAndGet"] = "SPEND_AND_GET";
    /**
     * A goal with a transaction count requirement which when hit unlocks a reward
     */
    GoalType["TransactionCounter"] = "TRANSACTION_COUNTER";
    /**
     * A goal with an action count requirement which when hit unlocks the points entries earned in the goal.
     * Used exclusively for Simon at this time
     */
    GoalType["UnlockAndEarnActionCount"] = "UNLOCK_AND_EARN_ACTION_COUNT";
    GoalType["Unspecified"] = "GOAL_TYPE_UNSPECIFIED";
})(GoalType || (exports.GoalType = GoalType = {}));
/** @see https://cardless.sourcegraph.com/github.com/cardlesshq/java/-/blob/proto-registry/cardless/proto/rewards/api/rewards_enum.proto?L28 */
var RewardsError;
(function (RewardsError) {
    RewardsError["RewardsErrorUnspecified"] = "REWARDS_ERROR_UNSPECIFIED";
    /**
     * There are no gift cards currently available for a given brand and amount.
     * The user should be notified of this and asked to try purchasing a gift card again later.
     * "No gift cards of the given amount available".
     */
    RewardsError["NoGiftCardsAvailable"] = "NO_GIFT_CARDS_AVAILABLE";
    /**
     * The points balance is not high enough for the desired points redemption.
     * "Insufficient funds for points redemption."
     */
    RewardsError["InsufficientPointsBalance"] = "INSUFFICIENT_POINTS_BALANCE";
    /** Their points transfer account (e.g. Home Run Rewards) is blocked. */
    RewardsError["PointsTransferAccountBlocked"] = "POINTS_TRANSFER_ACCOUNT_BLOCKED";
    /** Their points transfer account (e.g. Home Run Rewards) is expired. */
    RewardsError["PointsTransferAccountExpired"] = "POINTS_TRANSFER_ACCOUNT_EXPIRED";
    /** Their points transfer account (e.g. Home Run Rewards) does not exist. */
    RewardsError["PointsTransferAccountNotFound"] = "POINTS_TRANSFER_ACCOUNT_NOT_FOUND";
    /** Their points transfer account (e.g. Home Run Rewards) is not permitted. */
    RewardsError["PointsTransferAccountNotPermitted"] = "POINTS_TRANSFER_ACCOUNT_NOT_PERMITTED";
    /**
     * The specific brand shop product is no longer available.
     * "Product is no longer available".
     */
    RewardsError["BrandShopProductNotAvailable"] = "BRAND_SHOP_PRODUCT_NOT_AVAILABLE";
    /** Returned when a customer tries to redeem points for a statement credit amount > account balance */
    RewardsError["InsufficientAccountBalance"] = "INSUFFICIENT_ACCOUNT_BALANCE";
    /** Returned when a customer tries to link an external rewards account that is already linked to another cardless account */
    RewardsError["ExternalRewardsAccountInUse"] = "EXTERNAL_REWARDS_ACCOUNT_IN_USE";
    /** Returned when partner does not support checking for user existence */
    RewardsError["UserExistenceCheckNotSupported"] = "USER_EXISTENCE_CHECK_NOT_SUPPORTED";
    /** Returned when partner returns an error when checking for user existence */
    RewardsError["PartnerReturnedError"] = "PARTNER_RETURNED_ERROR";
})(RewardsError || (exports.RewardsError = RewardsError = {}));
/**
 * @todo these are values from Qatar... need to be generalized for Cardless
 */
var RewardsAccountLookupError;
(function (RewardsAccountLookupError) {
    RewardsAccountLookupError["FFP_PHONE_NUM_LEN_INV"] = "FFP_PHONE_NUM_LEN_INV";
    RewardsAccountLookupError["FFP_EMAIL_LEN_INV"] = "FFP_EMAIL_LEN_INV";
    RewardsAccountLookupError["FFP_EMAIL_MDT"] = "FFP_EMAIL_MDT";
    RewardsAccountLookupError["FFP_EMAIL_INV"] = "FFP_EMAIL_INV";
    RewardsAccountLookupError["FFP_MBR_EXISTS_WITH_MOBILE"] = "FFP_MBR_EXISTS_WITH_MOBILE";
    RewardsAccountLookupError["FFP_MBR_EXISTS_WITH_EMAIL"] = "FFP_MBR_EXISTS_WITH_EMAIL";
    RewardsAccountLookupError["FFP_MBR_EXISTS_DIFF_CUST"] = "FFP_MBR_EXISTS_DIFF_CUST";
    RewardsAccountLookupError["FFP_MBR_FNAME_MISMATCH"] = "FFP_MBR_FNAME_MISMATCH";
})(RewardsAccountLookupError || (exports.RewardsAccountLookupError = RewardsAccountLookupError = {}));
